/* @flow */

import { useSelector } from 'react-redux';
import { getMembershipTimezone } from 'src/shared/domain/membership/selector/membershipSelectors';

export default function useMembershipTimezone(): ?string {
  return useSelector(getMembershipTimezone);
}
